import {MatSnackBarRef, SimpleSnackBar} from '@angular/material/snack-bar';
import {TableColumn} from '../../shared/customize-table-columns/customize-table-columns.component';

export interface CreateDiscountResponse {snackBarRef: MatSnackBarRef<SimpleSnackBar>; refreshTable: boolean}

export const discountRuleTypeMap = {
  exclusive: 'd32e3ba4-aa30-4b19-88da-b17f4c8d138d',
  restricted: 'ac581f0e-e419-4d86-a45f-2fb5a1d490e2',
  qualified: 'ef187fae-f01c-40aa-9922-6da0a845c525'
};

export const allTableColumns: TableColumn[] = [
  {
    name: 'discount_name',
    displayName: 'Discount Title',
    entityType: ['affiliates', 'merchants']
  },
  {
    name: 'discount_description',
    displayName: 'Discount Details',
    entityType: ['affiliates', 'merchants']
  },
  {
    name: 'merchant_name',
    displayName: 'Merchant',
    entityType: ['affiliates']
  },
  {
    name: 'discount_entity_name',
    displayName: 'Designated Affiliates',
    entityType: ['merchants']
  },
  {
    name: 'coupon_code',
    displayName: 'Coupon Code',
    entityType: ['affiliates', 'merchants']
  },
  {
    name: 'discount_rule_type_name',
    displayName: 'Rule Type',
    entityType: ['affiliates', 'merchants']
  },
  {
    name: 'discount_status',
    displayName: 'Status',
    entityType: ['merchants']
  },
  {
    name: 'started_at',
    displayName: 'Start Date',
    entityType: ['affiliates', 'merchants']
  },
  {
    name: 'expired_at',
    displayName: 'End Date',
    entityType: ['affiliates', 'merchants']
  },
  {
    name: 'updated_at',
    displayName: 'Last Updated',
    entityType: ['affiliates', 'merchants']
  },
];

export const createDiscountWidth = '854px';
